export default {
  "operationRecord.thead.index": "#序号",
  "operationRecord.thead.operator": "操作人",
  "operationRecord.thead.sourceType": "来源类型",
  "operationRecord.thead.actionType": "操作类型",
  "operationRecord.thead.before": "操作前",
  "operationRecord.thead.after": "操作后",
  "operationRecord.thead.actionTime": "操作时间",
  "operationRecord.thead.actionTimeFrom": "开始时间",
  "operationRecord.thead.actionTimeTo": "结束时间",
  "operationRecord.tooltip.copy": "复制用户编号",
  "operationRecord.tooltip.showUserDetails": "显示用户详细",
};
